import { Flowbite, useThemeMode } from "flowbite-react";
import type { FC } from "react";
import { useEffect } from "react";
import { Outlet } from "react-router";
import theme from "../flowbite-theme";

const ThemeControl: FC = function () {
  const dark = localStorage.getItem("theme") === "dark";

  return (
    <Flowbite theme={{ dark, theme }}>
      <SaveThemeToLocalStorage />
      <Outlet />
    </Flowbite>
  );
};

const SaveThemeToLocalStorage: FC = function () {
  // Use object destructuring instead of array destructuring:
  const { mode: themeMode } = useThemeMode();

  useEffect(() => {
    localStorage.setItem("theme", themeMode);
  }, [themeMode]);

  return <></>;
};

export default ThemeControl;
